import React from 'react'

const FooterForm = (props) => {

  return (
    <div id="mc_embed_signup">
        <form action="https://zornsofbethpage.us8.list-manage.com/subscribe/post?u=9bb61ac9cf73d1e020e6bcee1&amp;id=a008fdd587" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
            <div id="mc_embed_signup_scroll">
                <div className="indicates-required"><span className="asterisk">*</span> indicates required</div>
                <div className="mc-field-group">
                    <label htmlFor="mce-EMAIL">Email<span className="asterisk">*</span></label>
                    <input type="email" name="EMAIL" className="required email" id="mce-EMAIL"/>
                </div>
                <div id="mce-responses" className="clear foot">
                    <div className="response" id="mce-error-response"></div>
                    <div className="response" id="mce-success-response"></div>
                </div>  
                <div className="offscreen" aria-hidden="true">
                    <input type="text" name="b_9bb61ac9cf73d1e020e6bcee1_a008fdd587" tabIndex="-1" />
                </div>
                <div className="optionalParent">
                    <div className="clear foot">
                        <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="button"/>
                    </div>
                </div>
            </div>
        </form>
    </div>
    
  )
}

export default FooterForm

